export default "__VITE_ASSET__CGCnVjDQ__"